import React from 'react';
import PropTypes from 'prop-types';
import LogInForm from '@/shared/components/account/loginForm/LogInForm';
import {
  AccountCard,
  AccountContent,
  AccountHead,
  AccountLogo,
  AccountPhoto,
  AccountLogoAccent,
  AccountTitle,
  AccountWrap,
} from '@/shared/components/account/AccountElements';
import Forgot from '../../../shared/components/account/forgot_form/Forgot';
import { SignInLogo } from '../../Layout/components/topbar/BasicTopbarComponents';

const auth0Icon = `${process.env.PUBLIC_URL}/img/auth0.svg`;

const ForgotForm = () => (
  <AccountPhoto>
    <AccountContent>
      <AccountCard>
        <AccountHead>
          <AccountTitle>
            <SignInLogo />
          </AccountTitle>
          {/* <h4 className="subhead" /> */}
        </AccountHead>
        <Forgot form="forgot_form" />
        {/* <AccountOr>
          <p>Or Easily Using</p>
        </AccountOr> */}
        {/* Add other social login buttons as needed */}
        
      </AccountCard>
    </AccountContent>
  </AccountPhoto>
  );

// LogIn.propTypes = {
//   changeIsOpenModalFireBase: PropTypes.func.isRequired,
// };

export default ForgotForm;
